import { useActiveRouteName } from '../../navigation/useActiveRouteName';

export const useKustomerNavigation = () => {
  const route = useActiveRouteName();

  return { canShowKustomerWidget: route === 'AccountTab' };
};
